import { graphql } from 'react-relay';

import { commit } from './commit';

const mutation = graphql`
  mutation deleteMessageMutation(
    $input: DeleteMessageInput!
    $kind: MessageKind!
  ) {
    deleteMessage(input: $input) {
      destroyedMessageId
      lists {
        ...MessagesList_lists
      }
    }
  }
`;

const deleteMessage = (environment, messageId, listsId, args = {}) => {
  return commit(environment, {
    mutation,
    variables: {
      input: {
        id: messageId,
      },
      kind: 'active',
    },
    configs: [
      {
        type: 'RANGE_DELETE',
        parentID: listsId,
        connectionKeys: [{ key: 'MessagesList_messages' }],
        pathToConnection: ['lists', 'messages'],
        deletedIDFieldName: 'destroyedMessageId',
      },
    ],
    ...args,
  });
};

export default deleteMessage;
